import * as React from 'react'
import { Grid, Typography } from '@material-ui/core'
import AnimatedPhoneSet from '../AnimatedPhoneSet'
import AnimatedText from '../AnimatedText'
import EndIconButton from '../EndIconButton'
import { useStyles } from './PromoItem.style'

const PromoItem = ({
  title,
  description,
  animationPath,
  placeholderPath,
  reverse,
  cta,
}) => {
  const props = { reverse, placeholderPath }
  const styles = useStyles(props)

  return (
    <Grid spacing={0} container alignItems="center" className={styles.root}>
      <Grid item xs={12} sm={12} md={5} className={styles.promoTextContainer}>
        <AnimatedText
          textClass={styles.title}
          isXray
          variant="h3"
          content={title}
        />
        <Typography className={styles.description} variant="body1">
          {description}
        </Typography>
        {cta && (
          <EndIconButton
            className={styles.cta}
            link={cta.link}
            title={cta.title}
          />
        )}
      </Grid>
      {(animationPath || placeholderPath) && (
        <Grid item xs={12} sm={12} md={7} className={styles.animationContainer}>
          <AnimatedPhoneSet
            animationPath={animationPath}
            style={styles.lottie}
            placeholderPath={placeholderPath}
          />
        </Grid>
      )}
    </Grid>
  )
}

export default PromoItem
